import React from "react";
import styled from "@emotion/styled";
// components
import { DefaultLayout } from "../../components/layout/defaultLayout";
import { PageHeading } from "../../components/heading/pageHeading";
import { BreadcrumbBar } from "../../components/bar/breadcrumbBar";
import { SectionHeading } from "../../components/heading/sectionHeading";
import { ItemCard } from "../../components/card/itemCard";
// utils
import { Color } from "../../utils/color";
import { ItemLists } from "../../utils/itemLists";
// breadcrumb
const breadcrumbs = [
  { txt: "トップ", url: "/" },
  { txt: "ジャンルから探す", url: "/genre" },
  { txt: "ジャンル01", url: "/genre/genre01" },
];
// genre === genre01を抽出
const Genre01ItemLists = ItemLists.filter((Item) => {
  return Item.genre === "genre01";
});

const Genre01Page = () => {
  return (
    <DefaultLayout pageTitle="ジャンル01">
      <PageHeading enTxt="GENRE01" jpTxt="ジャンル01" />
      <BreadcrumbBar breadcrumbs={breadcrumbs} />
      <SSection>
        <SContainer>
          <SectionHeading txt="ジャンル01の製品" />
          <SWrapper>
            {Genre01ItemLists.map(({ id, name, price, brand, url, img }) => {
              return (
                <ItemCard
                  key={id}
                  name={name}
                  price={price}
                  brand={brand}
                  url={url}
                  img={img}
                />
              );
            })}
          </SWrapper>
        </SContainer>
      </SSection>
    </DefaultLayout>
  );
};

export default Genre01Page;

const SSection = styled.section`
  padding: 4rem 0;
  border-bottom: 1px solid ${Color.gray100};
  /* ---------- */
  /* tb */
  @media screen and (max-width: 1023px) {
    padding: 2rem 0;
  }
`;

const SContainer = styled.div`
  width: 96%;
  max-width: 1366px;
  margin: auto;
`;

const SWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(200px, 100%), 1fr));
  gap: 1rem;
  /* ---------- */
  /* tb */
  @media screen and (max-width: 1023px) {
    grid-template-columns: repeat(auto-fit, minmax(min(160px, 100%), 1fr));
    gap: 0.5rem;
  }
`;
